// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3X-h2","head":"ProcedureTableInfo_head__2Hw_w"};